var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldEmblemFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.563 26.3019C21.6138 25.0163 28.8101 21.045 28.8101 12.1873V6.83593C28.8101 5.32834 28.8101 4.57342 28.4947 3.99703C28.2169 3.48953 27.7726 3.07721 27.2275 2.81863C26.6078 2.52466 25.7977 2.52466 24.1752 2.52466H10.2693C8.64685 2.52466 7.83499 2.52466 7.21528 2.81863C6.67017 3.07721 6.2273 3.48953 5.94955 3.99703C5.63379 4.57398 5.63379 5.32982 5.63379 6.84036V12.1872C5.63379 21.045 12.8298 25.0163 15.8806 26.3019C16.204 26.4382 16.3665 26.5062 16.7326 26.5647C16.9635 26.6016 17.4819 26.6016 17.7128 26.5647C18.0776 26.5064 18.2384 26.4387 18.5596 26.3033L18.563 26.3019Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldEmblemFill);
export default __webpack_public_path__ + "static/media/ShieldEmblemFill.1ee34f81e07b4d2b98dc37ab58ebf029.svg";
export { ForwardRef as ReactComponent };